// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__xbaBf","validationTips":"StatementDescriptor_validationTips__VgYEY"};